<template>
  <!-- 签署授信合同 -->
  <div>
    <ul>
      <component
        v-for="(item, index) in elementData[0].components"
        :key="index"
        :is="item.component"
        :dataInfo="item"
      ></component>
      <div v-if="showContract">
        <Contract
          text="本人已阅读并完全同意"
          :list="elementData[0].contracts"
          :defaultCheck="false"
          v-model="isAgree"
        />
      </div>
      <!-- <contract-full
        @getBtnStatus="getBtnStatus"
        :list="elementData[0].contracts"
      ></contract-full> -->
    </ul>
    <Button
      :text="draw"
      :type="danger"
      class="nextStep"
      :disabled="!isAgree"
      :click="submitContract"
    />
    <server-bank
      :productId="this.$route.query.productId"
      :isRelative="true"
    ></server-bank>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import Button from '@/components/Button.vue';
import ContractInfo from '@/components/ContractInfo.vue';
import ContractFull from '@/components/ContractFull.vue';
import ServerBank from '@/components/ServerBank.vue';
import Contract from '@/components/Contract.vue';
import { Toast } from 'vant';

export default {
  name: 'signContractStandard',
  data() {
    return {
      danger: 'danger',
      draw: '确认签署',
      // 动态渲染组件 - 非可编辑
      elementData: [{}],
      isDisabled: false,
      isAgree: false,
      showContract: false,
    };
  },
  components: {
    Button,
    ContractInfo,
    ContractFull,
    ServerBank,
    Contract,
  },
  computed: {
    ...mapState({
      otherPages(val) {
        for (const i in this.elementData.components) {
          this.$set(this.elementData.components[i], 'value', val.otherPages.creditContractObj[this.elementData.components[i].key]);
        }
        return val.otherPages;
      },
    }),
  },
  watch: {
    otherPages: { // 监听事件勿删
      handler(newval) {
      },
    },
  },
  mounted() {
    this.getPageConfig();
  },
  methods: {
    // 获取合同页配置
    getPageConfig() {
      // this.elementData = [
      //   {
      //     components: [
      //       {
      //         component: 'contractInfo',
      //         label: '授权合同编号',
      //         key: 'creditId',
      //       }, {
      //         component: 'contractInfo',
      //         label: '合同平台名称',
      //         key: 'platName',
      //       }, {
      //         component: 'contractInfo',
      //         label: '授信额度（小写）',
      //         key: 'loanAmt',
      //         firstUnit: '￥',
      //       }, {
      //         component: 'contractInfo',
      //         label: '授信额度（大写）',
      //         key: 'loanAmtCn',
      //       }, {
      //         component: 'contractInfo',
      //         label: '支用起点金额（大写）',
      //         key: 'beginAmtCn',
      //       }, {
      //         component: 'contractInfo',
      //         label: '授信额度有效期',
      //         key: 'loanExp',
      //       }, {
      //         component: 'contractInfo',
      //         label: '授信起始日期',
      //         key: 'loanStartDate',
      //       }, {
      //         component: 'contractInfo',
      //         label: '授信到期日期',
      //         key: 'loanEndDate',
      //       },
      //     ],
      //     contracts: [
      //       {
      //         text: '浦银快贷个人授信合同',
      //         value: 'PufaCredit',
      //       },
      //     ],
      //   },
      // ];
      // this.getContractInfo();
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$api.PublicPage.getProductConfig({
        pageId: this.$route.query.pageId, // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面
        productId: this.$route.query.productId,
      }).then((res) => {
        if (res.success) {
          const result = JSON.parse(res.data[0].productConfigs);
          localStorage.setItem('configData', res.data[0].productConfigs);
          this.elementData = [...result];
          this.showContract = true;
          this.getContractInfo();
        }
        this.$toast.clear();
      });
    },
    // 查询合同信息
    async getContractInfo() {
      const { data, success, returnMessage } = await this.$api.OtherPage.queryEchoInfo({
        pageId: this.$route.query.pageId, // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面
        orderId: this.$route.query.orderId,
      });
      if (!success) {
        this.$toast(returnMessage || '获取数据失败');
        return;
      }
      for (const i in this.elementData[0].components) {
        this.$set(this.elementData[0].components[i], 'value', data[this.elementData[0].components[i].key]);
      }
    },
    // 合同签署
    async submitContract() {
      try {
        this.$loading.show('合同签署中...');
        const { success, returnMessage } = await this.$api.OtherPage.commitApply({
          pageId: this.$route.query.pageId, // 0:进件页面 1:授信合同签署页面 2:提款申请页面 3:提款合同签署页面 4:还款试算页面
          orderId: this.$route.query.orderId,
        });
        this.$loading.hide();
        if (success) {
          this.$store.dispatch('otherPages/jumpCurrPageServer');
        } else {
          Toast(returnMessage);
        }
      } catch (e) {
        Toast('签署合同失败');
      }
    },
    getBtnStatus(val) {
      this.isDisabled = !val;
    },
  },
};
</script>
<style scoped>
.popupStyle {
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
}
.nextStep {
  margin-top: 100px;
  /* margin-bottom: 12px; */
}
.contractDraw {
  width: 92%;
  height: 40px;
  margin: auto;
  color: rgba(212, 48, 48, 1);
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  border: 1px solid rgba(212, 48, 48, 1);
  border-radius: 3px;
}
</style>
